import { useEffect, useState } from "react";
import { Input, Tag } from "antd";
import { useDynamicFormStore } from "@stores/dynamicFormStore";

const MultiInsertField = ({ className, handleRulesOnValueChange, validations, displayId }: any) => {
  const [tags, setTags] = useDynamicFormStore((state) => [state.tags[displayId] || [], state.setTags]);
  const [inputValue, setInputValue] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const {maxLength, codeLength} = validations
  const disableInput = tags.length >= codeLength;

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter((tag: any) => tag !== removedTag);
    setTags(displayId, newTags);
  };

  const handleInputChange = (e: any) => {
    let value = e.target.value;
    
    if (displayId === "healthnet_icd_codes") {
      value = value.replace(/[^a-zA-Z0-9]/g, "");
    } else {
      value = value.replace(/[^a-zA-Z0-9.]/g, "");
      // Prevent multiple decimal points
      if ((value.match(/\./g) || []).length > 1) {
        value = value.replace(/\.+$/, "");
      }
    }
    setInputValue(value);
    setErrorMessage("");
    handleRulesOnValueChange(value);
  };

  const handleInputConfirm = () => {
    if (inputValue.trim() !== "") {
      if (tags.includes(inputValue.trim())) {
        setErrorMessage("Code already exists");
      } else {
        const newTags = [...tags, inputValue.trim()];
        setTags(displayId, newTags);
        handleRulesOnValueChange(newTags.join("$|"));
        setInputValue("");
      }
    }
  };

  useEffect(() => {
    if (disableInput) {
      setErrorMessage("Maximum Code limit reached");
    } else {
      setErrorMessage("");
    }
  }, [disableInput]);

  return (
    <div className={`${className}__multiInsert`}>
      <Input
        type="text"
        size="large"
        value={inputValue}
        onChange={handleInputChange}
        onPressEnter={handleInputConfirm}
        placeholder="Enter Code and press enter key..."
        className={`${className}__multiInsert__input`}
        maxLength={maxLength}
        disabled={disableInput}
      />
      {errorMessage && (
        <div>
          <span className="errorIcon">{/* <Icon name="hrainfo" /> */}</span>
          <span className={`${className}__required f14 w400`}>{errorMessage}</span>
        </div>
      )}
      <div style={{ marginTop: 16 }}>
        <div>
          {tags.map((tag: any, index: any) => (
            <span key={tag} style={{ display: "inline-block", marginRight: 8, marginBottom: 8 }}>
              <Tag className={index === 0 ? "clr-themeColor" : ""} closable onClose={() => handleClose(tag)}>
                {tag}
              </Tag>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MultiInsertField;
